import { handleGqlResponseBody } from "@/utils/apollo.util";
import {GET_CURRENCY_PAGINATED_QUERY} from '@/graphql/currency/currency.query';

const adminSettings = {
  actions: {
    async getCurrencyPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_CURRENCY_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
  },
};

export default adminSettings;
